<template>
  <div>
    <div v-if="bookingHasNoShortlistedTalent" class="no-stars">
      <p>
        There are no {{ $t('shortlisted stars') }}.
      </p>
    </div>
    <ul v-else class="shortlist shortlist-horizontal shortlist-col-4">
      <booking-duplicate-shortlist-talent
        v-for="(talent, index) in bookingShortlistedTalent"
        :key="talent.id"
        :talent="talent"
        :index="index"
        :booking="booking"
        :remove-shortlisted-talent="removeShortlistedTalent"/>
    </ul>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import BookingDuplicateShortlistTalent from './BookingDuplicateShortlistTalent'

export default {
  mixins: [helpers],

  props: {
    booking: {
      type: Object,
      required: true
    },
    removeShortlistedTalent: {
      type: Function,
      required: true
    }
  },

  components: {
    BookingDuplicateShortlistTalent
  }
}
</script>
